import { IOption } from '../../shared/form/components/form-select/form-select.model';

export const SORT_OPTIONS = [
  {
    label: $localize`All`,
    value: 'ALL',
  },
];

export const CONST = {
  TRANSFER_ULD_MODAL: {
    HEADER: $localize`Transfer ULD`,
    ENTER_INFO: $localize`Please enter the NEW equipment information.`,
    EQUIPMENT_NUMBER: $localize`Equipment Number`,
    NUMBER_PLACEHOLDER: $localize`Enter Equipment Number`,
    EQUIPMENT_TYPE: $localize`Equipment Type`,
    TYPE_PLACEHOLDER: $localize`Enter Equipment Type`,
    CANCEL: $localize`Cancel`,
    TRANSFER: $localize`Transfer`,
  },
  MODAL: {
    HEADER: $localize`Close Window`,
    LINE1: $localize`Close the window?`,
    LINE2: $localize`Your changes will not be saved.`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
    BODY:
      $localize`Are you sure you want to close the window?` +
      ' ' +
      $localize`Your changes will not be saved.`,
  },
  CANCEL_MODAL: {
    HEADER: $localize`Cancel`,
    BODY: $localize`Are you sure you want to cancel? Your changes will not be saved.`,
    CONFIRM_BUTTON: $localize`Yes, Cancel`,
    REJECT_BUTTON: $localize`No`,
  },
  ULD_MODAL: {
    NEW: $localize`New ULD`,
    SELECT_DATE: $localize`Select Date`,
    SORT_DATE: $localize`Sort Date`,
    SELECT: $localize`Select`,
    SORT: $localize`Sort`,
    POSITION_BELT: $localize`Position (Belt)`,
    BELT_PLACEHOLDER: $localize`Enter Belt`,
    POSITION_BAY: $localize`Position (Bay)`,
    BAY_PLACEHOLDER: $localize`Enter Bay`,
    NEXT: $localize`Next`,
    BACK: $localize`Back`,
    LOAD: $localize`Load`,
    SELECT_LOAD: $localize`Select Load`,
    MOVEMENT: $localize`Movement`,
    SUBMIT: $localize`Submit`,
    SEAL_CONTROL: $localize`Seal Control`,
    SEAL_CONTROL_PLACEHOLDER: $localize`Enter Seal Control`,
    EDIT: $localize`Edit ULD`,
    SAVE: $localize`Save`,
    SELECTED_LOAD: $localize`Selected Load`,
    SELECTED_MOVEMENT: $localize`Selected Movement`,
    KEY_CHART: {
      HEADER: $localize`Key Chart`,
      CO: 'CO',
      BC: 'BC',
      BD: 'BD',
      UP: 'UP',
      CARRY_OVER: 'Carry Over',
      BULK_DELIVERY: 'Bulk Delivery',
      BULK_CARRYOVER: 'Bulk Carryover',
      UPS_PREMIER: 'UPS Premier',
    },
  },
  CLOSE_ULD: {
    HEADER: $localize`Close ULD`,
    PERCENTAGE: $localize`Percent Full`,
    PERCENTAGE_PLACEHOLDER: $localize`Enter Percent Full`,
    LOAD_NAME: $localize`Load Name`,
  },
};
export enum Ids {
  EQUIPMENT_NUMBER = 'equipmentNumber',
  EQUIPMENT_TYPE = 'equipmentType',
}

export enum FORM_STEP {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export enum ULD_FORM_Ids {
  SORT_DATE = 'sortDate',
  SORT = 'sort',
  POSITION_BELT = 'positionBelt',
  POSITION_BAY = 'positionBay',
  LOAD = 'load',
  MOVEMENT = 'movement',
  EQUIPMENT_NUMBER = 'equipmentNumber',
  EQUIPMENT_TYPE = 'equipmentType',
  SEAL_CONTROL = 'sealControl',
  PERCENTAGE = 'percentage',
}
export const TYPE_OPTIONS: IOption[] = [
  {
    label: $localize`Container - C`,
    value: 'C',
  },
  {
    label: $localize`Belly - BE`,
    value: 'BE',
  },
  {
    label: $localize`Package Car - PC`,
    value: 'PC',
  },
  {
    label: $localize`Cage - CG`,
    value: 'CG',
  },
  {
    label: $localize`Building Location - BL`,
    value: 'BL',
  },
  {
    label: $localize`Trailer - T`,
    value: 'T',
  },
  {
    label: $localize`Bag - B`,
    value: 'B',
  },
];

export const SORT_LIST: IOption[] = [
  {
    label: $localize`Sunrise - S`,
    value: 'S',
  },
  {
    label: $localize`Morning - M`,
    value: 'M',
  },
  {
    label: $localize`Day - D`,
    value: 'D',
  },
  {
    label: $localize`Twilight - T`,
    value: 'T',
  },
  {
    label: $localize`Night - N`,
    value: 'N',
  },
  {
    label: $localize`Preload - P`,
    value: 'P',
  },
  {
    label: $localize`Local - L`,
    value: 'L',
  },
  {
    label: $localize`Afternoon - A`,
    value: 'A',
  },
];

export const LOAD_OPTIONS = [
  {
    label: $localize`UPST45`,
    value: 'UPST45',
  },
  {
    label: $localize`US 1719 T GND`,
    value: 'US 1719 T GND',
  },
];

export const MOVEMENT_OPTIONS = [
  {
    label: $localize`MOVEMENT2`,
    value: 'MOVEMNT2',
  },
  {
    label: $localize`NOTEMA99`,
    value: 'NOTEMA99',
  },
  {
    label: $localize`NOTEMA99`,
    value: 'NOTEMA99',
  },
];

export const INTERNATIONAL_CODE = ['GB'];
export const INTERNATIONAL = 'INTERNATIONAL';
export const DOMESTIC = 'DOMESTIC';
